import { useContext } from 'react';
import EventEmitter from 'eventemitter3';

import { EventEmitterContext } from '../context/EventEmitterContext';

export function useEventEmitter() {
  const context = useContext(EventEmitterContext);

  return context as EventEmitter;
}
